{
  "name": "@altairgraphql/app",
  "description": "Contains the altair app",
  "version": "8.4.1",
  "author": "Samuel Imolorhe <hello@altairgraphql.dev> (https://altairgraphql.dev/)",
  "dependencies": {
    "@altairgraphql/api-utils": "workspace:*",
    "@altairgraphql/db": "workspace:*",
    "@altairgraphql/electron-interop": "workspace:*",
    "@altairgraphql/tauri": "workspace:*",
    "@angular/animations": "20.3.3",
    "@angular/cdk": "20.2.7",
    "@angular/cli": "20.3.4",
    "@angular/common": "20.3.3",
    "@angular/core": "^20.3.3",
    "@angular/forms": "20.3.3",
    "@angular/platform-browser": "20.3.3",
    "@angular/platform-browser-dynamic": "20.3.3",
    "@angular/platform-server": "20.3.3",
    "@angular/router": "20.3.3",
    "@apollo/client": "3.5.6",
    "@codemirror/autocomplete": "^6.18.4",
    "@codemirror/commands": "^6.7.1",
    "@codemirror/lang-javascript": "^6.2.2",
    "@codemirror/lang-json": "^6.0.1",
    "@codemirror/language": "^6.10.8",
    "@codemirror/lint": "^6.8.4",
    "@codemirror/search": "^6.5.8",
    "@codemirror/state": "^6.5.0",
    "@codemirror/view": "^6.36.1",
    "@emotion/css": "^11.11.2",
    "@fontsource/jetbrains-mono": "4.2.2",
    "@lezer/common": "1.2.1",
    "@lezer/highlight": "1.2.1",
    "@lezer/lr": "1.2.0",
    "@ngneat/hot-toast": "2.0.1",
    "@ngneat/overview": "1.0.0",
    "@ngneat/until-destroy": "8.0.1",
    "@ngrx/effects": "15.4.0",
    "@ngrx/store": "15.4.0",
    "@ngrx/store-devtools": "15.4.0",
    "@ngui/auto-complete": "3.0.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@sentry/electron": "^6.6.0",
    "@supabase/supabase-js": "1.29.1",
    "@webcomponents/custom-elements": "1.4.1",
    "abab": "2.0.6",
    "actioncable": "5.2.8",
    "ajv": "^8.11.2",
    "altair-graphql-core": "workspace:*",
    "angular-resizable-element": "^6.0.0",
    "angular-split": "^18.0.0",
    "apollo-cache-inmemory": "1.6.6",
    "apollo-link": "1.2.14",
    "apollo-link-http": "1.5.17",
    "aws-appsync-auth-link": "3.0.2",
    "aws-appsync-subscription-link": "3.0.3",
    "cm6-graphql": "0.0.14",
    "codemirror-graphql": "1.0.2",
    "codemirror-json-schema": "^0.6.0",
    "comlink": "4.3.0",
    "compare-versions": "^6.1.1",
    "cookie-parser": "1.4.5",
    "core-js": "3.6.5",
    "crypto-js": "3.3.0",
    "curlup": "1.0.0",
    "deepmerge": "4.2.2",
    "dexie": "3.2.3",
    "dompurify": "^3.1.6",
    "express": "^4.19.2",
    "file-dialog": "0.0.8",
    "file-saver": "2.0.2",
    "fuse.js": "6.4.6",
    "graphql": "15.5.1",
    "graphql-language-service": "^5.2.0",
    "graphql-language-service-parser": "1.10.4",
    "graphql-language-service-types": "1.8.2",
    "graphql-query-compress": "1.2.3",
    "graphql-ws": "5.9.1",
    "hotkeys-js": "^3.13.15",
    "json-bigint": "^1.0.0",
    "json-schema": "^0.4.0",
    "lodash-es": "4.17.21",
    "loglevel": "1.8.0",
    "loglevel-plugin-prefix": "0.8.4",
    "lucide-angular": "^0.298.0",
    "marked": "^15.0.3",
    "memoizee": "0.4.14",
    "ng-zorro-antd": "^15.1.1",
    "ngrx-store-localstorage": "12.0.1",
    "ngx-cookie-service": "14.0.1",
    "ngx-markdown": "^14.0.1",
    "ngx-pipes": "^3.2.2",
    "ngx-take-until-destroy": "5.4.0",
    "ngx-toastr": "^18.0.0",
    "nx": "17.1.3",
    "object-path": "0.11.5",
    "prettier": "^3.2.5",
    "rxjs": "7.8.1",
    "sanitize-html": "2.7.1",
    "subscriptions-transport-ws": "0.9.19",
    "sval": "0.4.8",
    "tslib": "2.0.0",
    "uuid": "9.0.1",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@altairgraphql/iframe-sandbox": "workspace:*",
    "@angular-eslint/builder": "20.3.0",
    "@angular-eslint/eslint-plugin": "20.3.0",
    "@angular-eslint/eslint-plugin-template": "20.3.0",
    "@angular-eslint/schematics": "20.3.0",
    "@angular-eslint/template-parser": "20.3.0",
    "@angular/build": "^20.3.4",
    "@angular/compiler": "20.3.3",
    "@angular/compiler-cli": "20.3.3",
    "@briebug/jest-schematic": "2.1.1",
    "@jest/globals": "28.1.3",
    "@ngrx/schematics": "12.4.0",
    "@playwright/test": "^1.31.2",
    "@sentry/cli": "^2.21.4",
    "@types/actioncable": "5.2.3",
    "@types/chrome": "^0.0.209",
    "@types/codemirror": "^5.60.15",
    "@types/crypto-js": "^4.0.1",
    "@types/dompurify": "^3.0.5",
    "@types/electron": "^1.6.10",
    "@types/file-saver": "^2.0.1",
    "@types/firefox-webext-browser": "^109.0.0",
    "@types/graphql": "^14.5.0",
    "@types/jest": "29.5.14",
    "@types/json-bigint": "^1.0.1",
    "@types/json-schema": "^7.0.6",
    "@types/lodash-es": "^4.17.4",
    "@types/memoizee": "^0.4.3",
    "@types/mousetrap": "^1.6.3",
    "@types/node": "^12.11.1",
    "@types/object-path": "^0.11.0",
    "@types/sanitize-html": "^2.6.2",
    "@types/to-snake-case": "^1.0.0",
    "@types/uuid": "^9.0.5",
    "@types/zen-observable": "^0.8.1",
    "@typescript-eslint/eslint-plugin": "^8.46.0",
    "@typescript-eslint/parser": "^8.46.0",
    "babel-plugin-transform-async-to-generator": "6.24.1",
    "babel-preset-env": "1.7.0",
    "babel-preset-react": "6.24.1",
    "chai": "4.2.0",
    "chai-as-promised": "7.1.1",
    "electron": "catalog:",
    "eslint": "^8.57.0",
    "eslint-config-altair": "workspace:*",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-import": "^2.27.4",
    "eslint-plugin-no-unsanitized": "^4.0.2",
    "eslint-plugin-prettier": "^5.1.3",
    "fake-indexeddb": "^4.0.1",
    "jest": "29.7.0",
    "jest-chrome": "^0.8.0",
    "jest-preset-angular": "^15.0.2",
    "karma-cli": "^2.0.0",
    "less": "^4.2.0",
    "ncp": "2.0.0",
    "ng-mocks": "^14.13.4",
    "ngrx-store-freeze": "0.2.4",
    "protractor": "7.0.0",
    "react": "17.0.1",
    "rxjs-tslint-rules": "4.32.0",
    "start-server-and-test": "1.11.0",
    "ts-jest": "29.0.5",
    "ts-mocks": "2.6.1",
    "ts-node": "9.1.1",
    "typescript": "catalog:"
  },
  "homepage": "https://altair-graphql.github.io/altair/",
  "license": "MIT",
  "main": "dist/browser/main.js",
  "private": true,
  "scripts": {
    "analyze": "ng build --stats-json && npx webpack-bundle-analyzer dist/stats.json",
    "analyze:prod": "ng build --aot --stats-json && npx webpack-bundle-analyzer dist/stats.json",
    "ng:build": "cross-env NODE_OPTIONS=--max-old-space-size=8192 pnpm ng build --aot --stats-json --output-hashing=none",
    "build": "node scripts/build.js",
    "lint": "ng lint",
    "new:component": "ng g component modules/altair/components/",
    "ng": "ng",
    "bootstrap": "pnpm build",
    "start": "ng serve",
    "sentry:sourcemaps:inject": "sentry-cli sourcemaps inject --org altair-graphql --project electron ./dist",
    "test": "jest && ng lint",
    "test-build": "ng lint && pnpm build && pnpm test-single-run",
    "test-single-run": "ng test --watch=false --code-coverage",
    "test:watch": "jest --watch"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/altair-graphql/altair.git"
  }
}
